;(function ($, window) {
  'use strict'

  window.eah = window.eah || {}

  eah.scrollToElite = (function () {
    const initialize = function () {
      $('.js-eliteScrollTo').click(function (e) {
        $('html,body').animate({
          scrollTop: $('#ea-elite .js-dropUpButton').offset().top
        }, 'slow')

        e.preventDefault()
      })

      $('.js-openEliteForm').click(function (e) {
        $('#ea-elite .js-dropUpButton').click()
        e.preventDefault()
      })
    }

    return {
      initialize: initialize
    }
  }())

  $(function () {
    eah.scrollToElite.initialize()
  })
}(jQuery, window))
